"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSource = exports.ExternalSourceType = void 0;
var ExternalSourceType;
(function (ExternalSourceType) {
    ExternalSourceType["SALESFORCE"] = "SALESFORCE";
    ExternalSourceType["SAP"] = "SAP";
    ExternalSourceType["DATA_UPLOAD"] = "DATA_UPLOAD";
    ExternalSourceType["NONE"] = "NONE";
})(ExternalSourceType = exports.ExternalSourceType || (exports.ExternalSourceType = {}));
var EventSource;
(function (EventSource) {
    EventSource["VAMSTAR"] = "VAMSTAR";
    EventSource["EXTERNAL"] = "EXTERNAL";
})(EventSource = exports.EventSource || (exports.EventSource = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0ZXJuYWwtc291cmNlLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tbW9uL2VudW1zL2V4dGVybmFsLXNvdXJjZS5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksa0JBS1g7QUFMRCxXQUFZLGtCQUFrQjtJQUM1QiwrQ0FBeUIsQ0FBQTtJQUN6QixpQ0FBVyxDQUFBO0lBQ1gsaURBQTJCLENBQUE7SUFDM0IsbUNBQWEsQ0FBQTtBQUNmLENBQUMsRUFMVyxrQkFBa0IsR0FBbEIsMEJBQWtCLEtBQWxCLDBCQUFrQixRQUs3QjtBQUVELElBQVksV0FHWDtBQUhELFdBQVksV0FBVztJQUNyQixrQ0FBbUIsQ0FBQTtJQUNuQixvQ0FBcUIsQ0FBQTtBQUN2QixDQUFDLEVBSFcsV0FBVyxHQUFYLG1CQUFXLEtBQVgsbUJBQVcsUUFHdEIifQ==